import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  ICreateCavalo,
  ICreateCavaloUpload,
  IEditCavalo
} from './cavalo.model';

@Injectable({
  providedIn: 'root'
})
export class CavaloService {
  constructor(private http: HttpClient) {}

  CreateCavalo(body: ICreateCavalo, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}Cavalo/CreateCavalo`,
      body,
      { headers: headers }
    );
  }

  CreateCavaloUpload(body: ICreateCavaloUpload, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}Cavalo/CreateCavalosByUpload`,
      body,
      { headers: headers, responseType: 'text' as 'json' }
    );
  }

  public GetCavalo({
    placa,
    marcaCavalo,
    idEmpresa,
    pageNumber,
    pageSize,
    paginar = true,
    status = 1
  }: {
    placa?: string;
    marcaCavalo?: string;
    idEmpresa?: string | null;
    pageNumber?: number;
    pageSize?: number;
    paginar?: boolean;
    status?: number;
  }): Observable<any> {
    const invalid = ['', undefined, 0, NaN];
    const url = `${environment.baseURL}Cavalo/GetCavalos`;
    const params: any = {};

    const placaNormalizada = placa !== undefined && placa !== null
      ? String(placa).replace(/-/g, '').trim()
      : '';
    if (placaNormalizada) {
      params.TX_PLCA_CAVA = placaNormalizada;
    }

    const marcaNormalizada = marcaCavalo !== undefined && marcaCavalo !== null
      ? String(marcaCavalo).trim()
      : '';
    if (marcaNormalizada) {
      params.TX_MDLO_CAVA = marcaNormalizada;
    }

    const empresaId = idEmpresa !== undefined && idEmpresa !== null
      ? Number(idEmpresa)
      : NaN;
    if (!Number.isNaN(empresaId) && empresaId > 0) {
      params.FK_EPSA = empresaId;
    }
    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }
    if (!paginar) {
      params.PAGE_SIZE = 2147483647;
    }

    params.NU_STTS_ALL = status;

    return this.http.get<any>(url, { params });
  }

  public GetCavaloById(id?: number): Observable<any> {
    const invalid = ['', undefined, 0, NaN];
    let url = `${environment.baseURL}Cavalo/GetCavaloById`;
    if (!invalid.includes(id)) {
      url += `?id=${id}`;
    }
    return this.http.get<any>(url);
  }

  public EditarCavalo(pkCavalo: number, body: IEditCavalo): Observable<any> {
    const url = `${environment.baseURL}Cavalo/UpdateCavalo?id=${pkCavalo}`;
    return this.http.put<any>(url, body);
  }

  public PatchCavaloEmpresa(
    carretaId: number,
    status: number
  ): Observable<any> {
    const url = `${environment.baseURL}Cavalo/PatchCavaloStatus?id=${carretaId}`;

    const body = {
      NU_STTS_CAVA: status
    };

    return this.http.patch(url, body);
  }
}
